import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent, DamItemVersion, DocumentExif, FileService} from 'compob2b-libs';
import {take, takeUntil} from 'rxjs/operators';
import {UtilsService} from '../../../../../../../../../../compob2b-customer/src/app/cabinet/utils/utils.service';
import {translations} from '../../../../../../../../environments/translations.ru';
import {DamService} from '../../../../../dam.service';
import {DamItemVersionsRenameComponent} from '../../../../dam-item-versions-rename/dam-item-versions-rename.component';
import {DamItemVersionTypeCountWSelected} from '../../../../dam-table/dam-catalog.component';

@Component({
  selector: 'app-dam-item-versions',
  templateUrl: './dam-item-versions.component.html',
  styleUrls: ['./dam-item-versions.component.scss'],
})
export class DamItemVersionsComponent extends BaseComponent {
  constructor(protected readonly fileService: FileService,
              public utils: UtilsService,
              protected readonly damService: DamService) {
    super();
  }

  @Input() modelId: string;
  @Input() write: boolean = false;
  @Input() currentVersion = null;
  @Input() versionsHistory: DamItemVersion[] = [];
  @Input() damItemVersions: DamItemVersion[] = [];
  @Input() fileExtensions: DamItemVersionTypeCountWSelected[] = [];

  @Input() exifIid: number;
  @Output() versionSelectEvent = new EventEmitter<DamItemVersion>();
  documentExifList: DocumentExif[] = [];
  filteredVersions = 0;

  clickedDamItemVersion: DamItemVersion = null;
  version = translations.version;
  versions = translations.versions;

  getExif(damItemVersionId: number, iid: number) {
    if (this.exifIid === iid) {
      return;
    }
    this.exifIid = iid;
    this.compoApiService.get<DocumentExif[]>('/dam/exif-data-of-version/' + damItemVersionId)
      .pipe(take(1))
      .subscribe(response => {
        this.documentExifList = response.data;
        this.cdr.detectChanges();
      });
  }

  getHistory(version: DamItemVersion) {
    this.clickedDamItemVersion = version;
    this.compoApiService.get<DamItemVersion[]>('/dam/' + version.id + '/versions-history').subscribe(response => {
      this.versionsHistory = response.data;
      this.cdr.detectChanges();
    });
  }

  public showThumbnail(mimeType) {
    return this.damService.showThumbnail(mimeType);
  }

  public getExtension(item): string {
    return this.damService.getExtension(item);
  }

  filterSidebarFilter($event) {
    this.damItemVersions.forEach(item => {
      if ($event.srcElement.value != '') {
        item.hideExpression = !item.header.toUpperCase().includes($event.srcElement.value.toUpperCase());
      } else {
        item.hideExpression = false;
      }
    });
    this.cdr.detectChanges();
  }

  formatBytes(a, b = 2) {
    if (!+a) {
      return '0 Bytes';
    }
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    return `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'][d]}`;
  }

  selectVersion(damItemVersion: DamItemVersion) {
    this.versionSelectEvent.emit(damItemVersion);
  }

  isAllExtensionsSelected = false;

  onAllFileExtensionsToggle(isSelected: boolean): void {
    this.toggleAll(this.fileExtensions, isSelected);
  }

  onFileExtensionToggle(index: number): void {
    this.fileExtensions[index].selected = !this.fileExtensions[index].selected;
    this.isAllExtensionsSelected = this.allItemsSelected(this.fileExtensions);
    this.filterVersions(this.damItemVersions);
  }

  allItemsSelected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => item?.selected));
  }

  allItemsUnselected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => !item?.selected));
  }

  toggleAll<T extends { selected: boolean }>(items: T[], selected: boolean) {
    this.isAllExtensionsSelected = selected;
    items.forEach(item => item.selected = selected);
    this.filterVersions(this.damItemVersions);
  }

  filterVersions(damItemVersions: DamItemVersion[]) {
    if (this.allItemsUnselected(this.fileExtensions)) {
      return damItemVersions;
    }

    const selectedExtensionsNames: string[] = this.fileExtensions.map(extension => {
      if (extension.selected) {
        return extension.typeOfFile;
      }
    }).filter(Boolean);

    this.filteredVersions = this.damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    }).length;

    return damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    });
  }

  drop(event: CdkDragDrop<DamItemVersion[]>) {
    if (this.write) {
      console.log('event', event);
      console.log('event.previousIndex', event.previousIndex);
      console.log('event.currentIndex', event.currentIndex);
      moveItemInArray(this.damItemVersions, event.previousIndex, event.currentIndex);
      console.log('damItemVersions after sort', this.damItemVersions);
      let sortedDamItemVersionIds = [];
      this.damItemVersions.forEach(item => {
        sortedDamItemVersionIds.push(item.id);
      });
      console.log('damItemVersions IDS after sort', sortedDamItemVersionIds);
      this.compoApiService.post('/dam/item-versions-sort/' + this.modelId, {
        sortedDamItemVersionIds
      }).pipe(takeUntil(this.unsubscribe)).subscribe();
    }
  }

  public download(id: number, header: string): void {
    this.fileService.downloadUrl('/dam/download/' + id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        FileService.saveAs(response, header);
      });
  }

  makeActual(damItemVersionHistoryId: number) {
    this.compoApiService.get('/dam/change-actual-dam-version/' + this.modelId + '/' + damItemVersionHistoryId)
      .pipe(takeUntil(this.unsubscribe)).subscribe(_ => {
      window.location.reload();
    });

  }

  modalRename(damItemVersionId, damItemVersionHeader) {
    const data = {
      damItemVersionId,
      damItemVersionHeader
    };
    const windowRef = this.windowService.open(DamItemVersionsRenameComponent, {
      context: data,
      title: translations.dam_rename,
      windowClass: 'catalogs-links-modal'
    });

    windowRef.onClose.subscribe(() => {
      this.loadDamItemVersions();
    });
  }

  loadDamItemVersions() {
    this.compoApiService.get<DamItemVersion[]>('/dam/' + this.modelId + '/versions').subscribe(response => {
      this.damItemVersions = response.data;
      this.cdr.detectChanges();
    });
  }
}
